import React from "react";
import I from "../component/Icon";
import BC from "./Breadcrumb";
import Bdg from "../component/Badge";

export default function FeesView({ fee, onBack }) {
  const total = Number(fee?.total || 0);
  const paid = Number(fee?.paid || 0);

  const pct = total > 0
    ? Math.round((paid / total) * 100)
    : 0;

  const initials = (fee?.studentName || "")
    .split(" ")
    .filter(Boolean)
    .map((w) => w[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  return (
    <>
      <BC
        items={["Fees", fee?.studentName || "Student"]}
        onBack={onBack}
      />

      <div style={{ display: "flex", gap: 14, flexWrap: "wrap" }}>

        <div style={{ flex: "0 0 248px" }}>

          {/* Student information */}
          <div
            className="card cp"
            style={{ marginBottom: 12 }}
          >
            <div
              style={{
                display: "flex",
                gap: 9,
                alignItems: "center",
                marginBottom: 12
              }}
            >
              <div
                className="av"
                style={{
                  width: 44,
                  height: 44,
                  fontSize: 14
                }}
              >
                {initials}
              </div>

              <div>
                <div
                  style={{
                    fontWeight: 700,
                    fontSize: 13.5
                  }}
                >
                  {fee?.studentName}
                </div>

                <div
                  style={{
                    fontSize: 11.5,
                    color: "var(--t3)"
                  }}
                >
                  {fee?.schoolName}
                </div>
              </div>
            </div>

            {/* Always Paid */}
            <Bdg
              type="green"
              label="Paid"
            />

            {/* Progress */}
            <div style={{ marginTop: 12 }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: 4
                }}
              >
                <span
                  style={{
                    fontSize: 11.5,
                    color: "var(--t3)"
                  }}
                >
                  Progress
                </span>

                <span
                  style={{
                    fontSize: 11.5,
                    fontWeight: 700,
                    color: "var(--gd)"
                  }}
                >
                  {pct}%
                </span>
              </div>

              <div
                className="pw"
                style={{ height: 7 }}
              >
                <div
                  className="pf pg"
                  style={{
                    width: `${pct}%`
                  }}
                />
              </div>
            </div>
          </div>

          {/* Payment information */}
          <div className="card cp">

            <div className="ir">
              <span className="ik">
                Total Fees
              </span>

              <span
                style={{
                  fontSize: 13.5,
                  fontWeight: 700,
                  color: "var(--t1)"
                }}
              >
                ₹{total.toLocaleString()}
              </span>
            </div>

            <div className="ir">
              <span className="ik">
                Paid
              </span>

              <span
                style={{
                  fontSize: 13.5,
                  fontWeight: 700,
                  color: "var(--gd)"
                }}
              >
                ₹{paid.toLocaleString()}
              </span>
            </div>

          </div>

        </div>
      </div>
    </>
  );
}